const cacheMap = new Map<string, { expiry: number; value: any }>();

export function Cacheable(ttlSeconds = 3600) {
  return function (
    target: any,
    propertyKey: string,
    descriptor: PropertyDescriptor,
  ) {
    const originalMethod = descriptor.value;

    descriptor.value = function (...args: any[]) {
      const cacheKey = `${propertyKey}_${JSON.stringify(args)}`;
      const cached = cacheMap.get(cacheKey);

      const now = Date.now();

      if (cached && cached.expiry > now) {
        return Promise.resolve(cached.value);
      }

      const result = originalMethod.apply(this, args);

      if (result instanceof Promise) {
        result.then(value => {
          cacheMap.set(cacheKey, {
            value,
            expiry: now + ttlSeconds * 1000,
          });
        });
      }

      return result;
    };

    return descriptor;
  };
}
